import { CREATEOPDOPERATION, DELETEOPDOPERATION, GETOPDOPERATION, UPDATEOPDOPERATION } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEOPDOPERATION:
            return {
                ...state,
                opdoperationSaveStatus: action.payload.success,
            }
        case GETOPDOPERATION:
                return {
                        ...state,
                        opdoperationList: action.payload.data,
                        }
        case UPDATEOPDOPERATION:
                return {
                        ...state,
                        opdoperationUpdateStatus: action.payload.success,
                        }   

        case DELETEOPDOPERATION:
                 return {
                     ...state,
                     opdoperationDeleteStatus: action.payload.success,
                        } 

                        default:
                            return state
                             }
                         }